module.exports = __webpack_public_path__ + "static/media/confluent.a9c3848e.jpg";